import { StyleSheet, View } from "react-native";
import StudentProfileMetrics from "../../../../components/adminDashboard/Analytics/components/StudentProfileMetrics";
import CustomSpacing from "../../../../components/common/layout/CustomSpacing/CustomSpacing";
import { spacing } from "../../../../styles/design-system";
import { GetCourseStudentInsightsQuery } from "@axio/graphql/generated/graphql";
import RecentActivityList from "../../../../components/adminDashboard/Analytics/components/RecentActivityList";
import AiAssessmentSummary from "../../../../components/adminDashboard/Analytics/components/AiAssessmentSummary";
import { formatTimeDifference } from "../../../../utils/date";
import TopStrugglingConcepts from "../../../../components/adminDashboard/Analytics/components/TopStrugglingConcepts";

interface RosterInsightOverviewContainerProps {
  studentInsights: NonNullable<GetCourseStudentInsightsQuery["getCourseStudentInsights"]["data"]> | null;
}

const RosterInsightOverviewContainer = ({ studentInsights }: RosterInsightOverviewContainerProps) => {
  const mapActivityType = (type?: string | null): string => {
    if (type === "AI_TUTOR") return "ILE";
    if (type === "ASSIGNMENT") return "Assignment";
    if (type === "PROJECT") return "Project";
    if (type === "MCQ") return "MCQ";
    if (type === "SOCRATIC DIALOG") return "Socratic";
    return type ?? "Activity";
  };

  const mapStatus = (status?: string | null): "Complete" | "In Progress" => {
    const s = (status || "").toLowerCase().trim();
    if (s === "completed" || s === "complete" || s === "pass") return "Complete";
    return "In Progress";
  };

  const mappedActivities = (studentInsights?.recentActivity ?? []).map((activity) => ({
    id: activity.activityId,
    title: activity.activityTitle,
    type: mapActivityType(activity.activityType),
    status: mapStatus(activity.status),
    timeCompleted: formatTimeDifference(activity.lastModified ?? activity.created),
  }));

  return (
    <View style={styles.container}>
      <StudentProfileMetrics studentInsights={studentInsights} />
      <CustomSpacing type="vertical" size="xl" />

      <AiAssessmentSummary
        aiAssessmentSummary={studentInsights?.courseSnapshot?.aiAssessmentSummary}
        aiRecommendations={studentInsights?.courseSnapshot?.aiRecommendations ?? []}
        aiNeedsIntervention={studentInsights?.courseSnapshot?.aiNeedsIntervention}
      />

      <CustomSpacing type="vertical" size="xl" />

      <TopStrugglingConcepts
        concepts={
          studentInsights?.confusionTopics?.map((topic) => ({
            id: topic.topicId,
            title: topic.title,
            activityCount: topic.activityCount ?? 0,
            struggleCount: topic.count ?? 0,
          })) ?? []
        }
      />

      <CustomSpacing type="vertical" size="xl" />

      <RecentActivityList activities={mappedActivities} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.lg,
  },
});

export default RosterInsightOverviewContainer;
